// extracted by mini-css-extract-plugin
module.exports = {"JobList":"JobList_JobList__2bkYF"};